import NewClient from "./NewClient";

export default NewClient;